import { EN_STANDARD_BRANCH_NAMESPACE } from '../core/types/interface';

export interface IPluginCommon {
  namespace: EN_STANDARD_BRANCH_NAMESPACE;
  symbol: any;
  description: string;
  allowMulti?: boolean;
  execute(...args: any): Promise<any> | any;
}

export function staticImplements() {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  return (_: IPluginCommon): void => {
    //
  };
}
